import { Action, createReducer, on } from '@ngrx/store';
import * as ProjectActions from '../actions';
import {
  IProject,
  IProjectDetail,
  IProjectPermissionGroups,
  IProjectUserAssociation,
  IProjectUserDetail,
  IProjectUsers,
} from '../../models/Project';

export interface ProjectsState {
  projectsList: IProject[];
  selectedProject: IProject | null;
  projectDetail: IProjectDetail | null;
  projectPermissionGroups: IProjectPermissionGroups[] | null;
  projectUser: IProjectUserAssociation | null;
  projectUsersList: IProjectUsers[] | null;
  selectProjectUser: IProjectUserDetail | null;
  retryingFailureId: number | null;
}

const initialState: ProjectsState = {
  projectsList: [],
  selectedProject: null,
  projectDetail: null,

  projectPermissionGroups: null,
  projectUser: null,
  projectUsersList: null,
  selectProjectUser: null,
  retryingFailureId: null,
};

export const projectsReducer = createReducer(
  initialState,
  on(ProjectActions.ProjectsApiActions.getProjectListSuccess, (state, { payload }) => ({
    ...state,
    projectsList: payload,
  })),
  on(ProjectActions.ProjectsApiActions.getProjectListError, (state) => ({
    ...state,
  })),
  on(ProjectActions.ProjectsUiActions.PostProject, (state) => ({
    ...state,
  })),
  on(ProjectActions.ProjectsApiActions.postProjectSuccess, (state) => ({
    ...state,
  })),
  on(ProjectActions.ProjectsApiActions.postProjectError, (state) => ({
    ...state,
  })),
  on(ProjectActions.ProjectsUiActions.SelectedProject, (state, { project }) => ({
    ...state,
    selectedProject: project,
  })),
  on(ProjectActions.ProjectsUiActions.ClearSelectedProject, (state) => ({
    ...state,
    selectedProject: null,
  })),

  on(ProjectActions.ProjectsUiActions.GetProjectDetails, (state) => ({
    ...state,
  })),
  on(ProjectActions.ProjectsApiActions.getProjectDetailsSuccess, (state, { payload }) => ({
    ...state,
    projectDetail: payload,
    retryingFailureId: null,
  })),
  on(ProjectActions.ProjectsApiActions.getProjectDetailsError, (state) => ({
    ...state,
  })),

  on(ProjectActions.ProjectsUiActions.GetProjectPermissionGroups, (state) => ({
    ...state,
  })),
  on(ProjectActions.ProjectsApiActions.getProjectPermissionGroupsSuccess, (state, { payload }) => ({
    ...state,
    projectPermissionGroups: payload,
  })),
  on(ProjectActions.ProjectsApiActions.getProjectPermissionGroupsError, (state) => ({
    ...state,
  })),
  on(ProjectActions.ProjectsUiActions.PostProjectUser, (state, { projectUser }) => ({
    ...state,
    projectUser,
  })),
  on(ProjectActions.ProjectsApiActions.postProjectUserSuccess, (state) => ({
    ...state,
  })),
  on(ProjectActions.ProjectsApiActions.postProjectUserError, (state) => ({
    ...state,
  })),
  on(ProjectActions.ProjectsUiActions.GetProjectUserList, (state) => ({
    ...state,
  })),
  on(ProjectActions.ProjectsApiActions.getProjectUsersSuccess, (state, { payload }) => ({
    ...state,
    projectUsersList: payload,
  })),
  on(ProjectActions.ProjectsApiActions.getProjectUsersError, (state) => ({ ...state })),
  on(ProjectActions.ProjectsUiActions.SelectProjectUser, (state, { projectUser }) => ({
    ...state,
    selectProjectUser: projectUser,
  })),
  on(ProjectActions.ProjectsUiActions.DeleteProjectUser, (state) => ({
    ...state,
  })),
  on(ProjectActions.ProjectsApiActions.deleteProjectUserSuccess, (state) => ({
    ...state,
  })),
  on(ProjectActions.ProjectsApiActions.deleteProjectUserError, (state) => ({
    ...state,
  })),
  on(ProjectActions.ProjectsUiActions.RetrySeqeraMember, (state, { failureId }) => ({
    ...state,
    retryingFailureId: failureId,
  })),
  on(ProjectActions.ProjectsApiActions.retrySeqeraMemberSuccess, (state, { failureId }) => ({
    ...state,
    retryingFailureId: null,
    // The user was added, so the backend dropped this failure record. Remove it
    // locally instead of reloading the whole project (which would flash the
    // full-screen loader over the open modal).
    projectDetail: state.projectDetail
      ? {
          ...state.projectDetail,
          seqera_membership_failures: (state.projectDetail.seqera_membership_failures ?? []).filter(
            (failure) => failure.id !== failureId
          ),
        }
      : state.projectDetail,
  })),
  on(ProjectActions.ProjectsApiActions.retrySeqeraMemberError, (state) => ({
    ...state,
    retryingFailureId: null,
  })),
);

export function ProjectsReducer(state: ProjectsState | undefined, action: Action) {
  return projectsReducer(state, action);
}
